/*
 * 一些工具函数
 * @Date: 2021-10-26 11:16:35
 * @LastEditTime: 2021-12-27 09:49:17
 */
//引入crypto 使用sha1加密
import crypto from 'crypto' 
import HTMLParser from '@/utils/html-parser.js'
/*
 * 通过出生日期获取年龄
 */
export function getAge(birthday) {
    // 新建日期对象
    let date = new Date()
        // 今天日期，数组，同 birthday
    let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
        // 分别计算年月日差值
    let age = today.map((value, index) => {
            return value - birthday[index]
        })
        // 当天数为负数时，月减 1，天数加上月总天数
    if (age[2] < 0) {
        // 简单获取上个月总天数的方法，不会错
        let lastMonth = new Date(today[0], today[1], 0)
        age[1]--
            age[2] += lastMonth.getDate()
    }
    // 当月数为负数时，年减 1，月数加上 12
    if (age[1] < 0) {
        age[0]--
            age[1] += 12
    }
    return age
}

/*
 * 获取URL参数
 */
export function getQueryString(name, string) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const _string = string ? string.split('?') : window.location.search
    const r = _string.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}

/*
 * 加密
 */
export function encryptData(beforeData, beforeVal, beData, beVal, p1, r1, p2, r2, p3, r3, p4, r4, p5, r5, p6, r6) {
    // data: "URL=9C48000487707842F6BEE1EC9E2E6A765409086E&API_KEY=CB47C9EAA32FA347311E8F1"
    // 拼接加密前的数据  a=1&b=2&c=3&api_key=12345
    const up = (beforeData + '=' + beforeVal + '&' + beData + '=' + beVal + '&' + p1 + '=' + r1 + '&' + p2 + '=' + r2 +
        '&' + p3 + '=' + r3 + '&' + p4 + '=' + r4 + '&' + p5 + '=' + r5 + '&' + p6 + '=' + r6 +
        '&api_key=cb47c9eaa32fa347311e8f1').toUpperCase();
    // console.log(up);
    // 引入sha1并加密
    const toSha1 = crypto.createHash('sha1');
    toSha1.update(up);
    // 加密后
    return toSha1.digest('hex');
}
   
/**
 * 转换html为node数组
 * @param {Object} htmlString
 */
export function parseHtml2Node(htmlString) {
    return HTMLParser(htmlString)
}

export const is_weixin = function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
};

export const is_WeixinOrAlipay = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    //判断是不是微信
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return "weixin";
    }
    //判断是不是支付宝
    if (ua.match(/AlipayClient/i) == "alipayclient") {
        return "alipay";
    }
    //哪个都不是
    return "";
};


// WEBPACK FOOTER //
// ./src/utils/index.js